import { CreateReportProps } from "./report.js"
import { TracingTaskProps } from "./moneyflow.js"
export enum TaskDefinition {
    Report = 'Report',
    Trace = 'Trace',
    Autotrace = 'Autotrace',
    EntityResolution = 'EntityResolution',
}

export enum TaskStatus {
    Pending = "Pending",
    Running = "Running",
    Completed = "Completed",
    Failed = "Failed",
    Cancelled = "Cancelled",
    Paused = "Paused",
    Queued = "Queued",
    Scheduled = "Scheduled",
    Timeout = "Timeout",
    Aborted = "Aborted",
    Retrying = "Retrying",
    Unknown = "Unknown",
}

interface TaskMeta {
    link: string
    documentId: string
    caseId: string
    status: TaskStatus
    error: string
    initiator: string
    createdAt: string
    updatedAt: string
}

export type TaskProps = {
    documentId: string
    name: string
}

export interface ReportTask extends TaskMeta {
    type: TaskDefinition.Report
    args: CreateReportProps
}

export interface TracingTask extends TaskMeta {
    type: TaskDefinition.Trace | TaskDefinition.Autotrace
    args: TracingTaskProps
}

export interface ResolutionTask extends TaskMeta {
    type: TaskDefinition.EntityResolution
    args: TaskProps
}

export type Task = ReportTask | TracingTask | ResolutionTask
